// src/components/sidebar/Sidebar.jsx
"use client";

import React from "react";
import GlassPanel from "../ui/GlassPanel";
import { Home, LayoutDashboard, Settings, Plug, FolderOpen, Bot } from "lucide-react";
import { cn } from "../../lib/utils";

export default function Sidebar({ active = "Home", onSelect }) {
  const items = [
    { label: "Home",         icon: <Home /> },
    { label: "Dashboard",    icon: <LayoutDashboard /> },
    { label: "Projects",     icon: <FolderOpen /> },
    { label: "Avatars",      icon: <Bot /> },
    { label: "Connect", icon: <Plug /> },
    { label: "Settings",     icon: <Settings /> },
  ];

  return (
    <aside className="fixed top-40 left-0 bottom-4 z-30">
      <GlassPanel className="h-full w-20 p-2 flex flex-col items-center">
        <ul className="flex flex-col space-y-6 items-center w-full mt-2">
          {items.map(({ label, icon }) => {
            const isActive = label === active;
            return (
              <li key={label} className="w-full flex justify-center">
                <button
                  onClick={() => onSelect(label)}
                  className={cn(
                    "flex items-center justify-center w-12 h-12 rounded-2xl transition relative",
                    isActive ? "bg-[#1C1431] shadow-sm" : "hover:bg-white/10"
                  )}
                  title={label}
                >
                  {React.cloneElement(icon, {
                    className: cn(
                      "h-6 w-6",
                      isActive ? "text-white" : "text-white/80"
                    ),
                    strokeWidth: 2,
                  })}
                </button>
              </li>
            );
          })}
        </ul>
      </GlassPanel>
    </aside>
  );
}